
function init_ticketnut_checkout(
  stripe_publish_key,
  stage_event_id,
  charges_new_tn_path,
  charges_confirm_payment_url,
  charges_confirm_rsvp_path,
  charges_capacity_available_path,
  is_rsvp_enabled,
  phrase_charge_please_accept_the_terms_of_service,
  phrase_charge_email_mismatch) {


  var starting_position_modal_inner_html = $("#artist-id-1").find(".modal-body").html();

  var stripe;
  var stripe_elements;
  var is_stripe_address_form_valid = false;
  var is_stripe_payment_form_valid = false;

  stripe = Stripe(stripe_publish_key);

  $(function () {


    function screen_one_handler(e) {

      $("#ticket_count").val($('#quantity_to_cart_10').val());
      serial_form = $("#preflight_form").find("input").filter(function (a) {
        return $(this).attr("id") != undefined
      }).serialize()



      data = serial_form;

      screen_two_handler_fn = !is_rsvp_enabled ? screen_two_handler : screen_two_rsvp_handler;

      $.ajax({
        type: "POST",
        url: charges_new_tn_path,
        data: data,
        dataType: "html",
        success: screen_two_handler_fn,
        error: (xhr, textStatus, errorThrown) => {
          response = JSON.parse(xhr.responseText)
          window.location = response.path;
          return;
        }

      });

      e.preventDefault();
    }


    function screen_two_handler(res) {
      document.getElementById('form-next').
        removeEventListener('click', screen_one_handler);

      $("#artist-id-1").find(".modal-body").html(res);

      document.getElementById('form-next').
        addEventListener('click', screen_two_handler_stripe);

      $("#submit-disabled-tooltip").attr('data-original-title', phrase_charge_please_accept_the_terms_of_service);
      $("#submit-disabled-tooltip").tooltip('enable');

      $("#form-next").prop('disabled', true);
      $("#form-next").attr('style', "pointer-events: none;");

      $('#chk-accept-terms').click((event) => {

        validate_screen_two();
        screen_two_handler_stripe(null);
      });

    }


    function screen_two_rsvp_handler(res) {
      document.getElementById('form-next').
        removeEventListener('click', screen_one_handler);

      $("#artist-id-1").find(".modal-body").html(res);

      document.getElementById('form-next').
        addEventListener('click', screen_two_rsvp_handler_confirm);

      $("#submit-disabled-tooltip").attr('data-original-title', "<%= t('charge.please_accept_the_terms_of_service') %>");
      $("#submit-disabled-tooltip").tooltip('enable');

      $("#form-next").prop('disabled', true);
      $("#form-next").attr('style', "pointer-events: none;");

      $('#chk-accept-terms').click((event) => {

        if (event.target.checked) {
          $("#form-next").prop('disabled', false);
          $("#form-next").attr('style', "");
          $("#submit-disabled-tooltip").tooltip('disable');
        } else {
          $("#form-next").prop('disabled', true);
          $("#form-next").attr('style', "pointer-events: none;");
          $("#submit-disabled-tooltip").tooltip('enable');
        }
      });

    }

    function screen_two_rsvp_handler_confirm(event) {
      serial_form = $("#new_form").find("input").filter(function (a) {
        return $(this).attr("id") != undefined
      }).serialize()


      $.ajax({
        type: "POST",
        url: charges_confirm_rsvp_path,
        data: serial_form,
        dataType: "html",
        success: function (res) {
          $("#artist-id-1").find(".modal-body").html(res);
          $('#form-next').hide()
          $('#form-dismiss').text('Close')
        }
      });

      e.preventDefault();
    }

    function validate_screen_two() {
      if (is_screen_two_valid()) {
        $("#form-next").prop('disabled', false);
        $("#form-next").attr('style', "");
        $("#submit-disabled-tooltip").tooltip('disable');
      } else {
        $("#form-next").prop('disabled', true);
        $("#form-next").attr('style', "pointer-events: none;");
        $("#submit-disabled-tooltip").tooltip('enable');
      }
    }

    function is_screen_two_valid() {
      return $("#accept_terms_confirmation").is(':checked') && is_stripe_payment_form_valid && is_stripe_address_form_valid; // && $("#accept_terms_confirmation").is(':checked'));
    }

    function screen_two_handler_stripe(event) {

      if (stripe_elements !== undefined) {
        return;
      }
      const appearance = {
        theme: 'stripe',
      };

      let clientSecret = $("#stripe_client_secret").val();

      stripe_elements = stripe.elements({ appearance, clientSecret });

      const paymentElementOptions = {
        layout: "tabs",
      };

      const paymentElement = stripe_elements.create("payment", paymentElementOptions);
      const addressElement = stripe_elements.create("address",
        {
          mode: 'billing',
          defaultValues: {
            name: $("#purchaser_name").val()
          }
        }
      );
      paymentElement.mount("#payment-element");
      addressElement.mount("#address-element");

      paymentElement.on('change', (event) => {
        if (event.complete) {
          is_stripe_payment_form_valid = true;
        } else {
          is_stripe_payment_form_valid = false;
        }
        validate_screen_two();
      })

      addressElement.on('change', (event) => {
        if (event.complete) {
          is_stripe_address_form_valid = true;
        } else {
          is_stripe_address_form_valid = false;
        }
        validate_screen_two();
      })

      document.getElementById('form-next').
        removeEventListener('click', screen_two_handler_stripe);

      //$("#artist-id-1").find(".modal-body").html("");

      document.getElementById('form-next').
        addEventListener('click', screen_two_handler_stripe_confirm_payment);


      if (event !== null) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    async function screen_two_handler_stripe_confirm_payment(event) {
      //setLoading(true);

      $("#form-next").prop('disabled', true);
      $("#form-next").attr('style', "pointer-events: none;");

      let clientSecret = $("#stripe_client_secret").val();
      let ticket_count = $("#ticket_count").val();

      let capacity_available = false
      let capacity_check_response = false;

      try {
        capacity_check_response = await $.ajax({
          type: "POST",
          url: charges_capacity_available_path,
          data: { provisional_ticket_count: ticket_count },
          dataType: "html"
        });
      } catch (error) {
        capacity_check_response = false;
      }

      capacity_available = Boolean(capacity_check_response);
      if (!capacity_available) {
        showMessage("Sorry, but tickets for this show are unavailable in the amount that you requested.");
        return;
      }


      const { error } = await stripe.confirmPayment({
        elements: stripe_elements,
        confirmParams: {
          return_url: charges_confirm_payment_url,
        },
      });


      if (error.type === "card_error" || error.type === "validation_error") {
        showMessage(error.message);
      } else {
        showMessage("An unexpected error occurred. Please refresh your browser or try a different payment method if the issue persists.");
      }

      // setLoading(false);

      event.preventDefault();
      event.stopPropagation();

    }

    $("#artist-id-1").on('hidden.bs.modal', function (event) {
      reset_modal_to_starting_position();
    });


    // Close Checkout on page navigation:
    window.addEventListener('popstate', function () {
      stripe_handler.close();
    });



    $(function () {
      $("a.support-artist").click(function (e) {


        e.stopPropagation();
        let timeslot_id = $(this).data('timeslot-id');
        let band_id = $(this).data('band-id');
        let band_name = $(this).data('band-name');

        if (timeslot_id) {
          window.history.pushState({}, "", "/buy/" + timeslot_id);
          $("#supporting-artist").text(band_name);
          $("#supporting-row").show();
        } else {
          $("#supporting-row").hide();
          window.history.pushState({}, "", "/buy_ga/" + stage_event_id);
          $("#is_general_admission").val(true);
        }

        $("#timeslot_id").val(timeslot_id);
        $("#band_id").val(band_id);
        $("#stage_event_id").val(stage_event_id);




        prepareFormValidation();


        $("#artist-id-1").modal('show');

        setTimeout(() => { $("#purchaser_email").focus() }, 500)

      });

      $("a.support-general-admission").click(function (e) {
        e.stopPropagation();
        let timeslot_id = null;
        let band_id = null;

        window.history.pushState({}, "", "/buy_ga/" + stage_event_id);


        $("#timeslot_id").val(null);
        $("#band_id").val(null);
        $("#stage_event_id").val(stage_event_id);
        $("#is_general_admission").val(true);

        $("#supporting-row").hide();

        prepareFormValidation();

        $("#artist-id-1").modal('show');

        setTimeout(() => { $("#purchaser_email").focus() }, 500)
      });

    })

    function prepareEmailConfirmationCheck() {
      $("#form-next").prop('disabled', true);
      $("#form-next").attr('style', "pointer-events: none;");
      $("#submit-disabled-tooltip").attr('data-original-title', phrase_charge_email_mismatch)
      $("#submit-disabled-tooltip").tooltip('enable');
      $("#purchaser_email").tooltip({
        placement: function () {
          if ($(document).width() > 991) {
            return 'left';
          } else {
            return 'top';
          }
        }
      });

      $("#purchaser_email").keyup(function () {
        validateForm();
      });

      $("#purchaser_email_confirm").keyup(function () {
        validateForm();
      });
    }


    function prepareTicketCountValidation() {
      $('#quantity_to_cart_10').keyup(function () {
        validateForm();
      });
    }

    function prepareFormValidation() {
      prepareEmailConfirmationCheck();
      prepareTicketCountValidation();
    }

    function validateForm() {
      if (isFormValid()) {
        $("#form-next").prop('disabled', false);
        $("#form-next").attr('style', "");
        $("#submit-disabled-tooltip").tooltip('disable');
      } else {
        $("#form-next").prop('disabled', true);
        $("#form-next").attr('style', "pointer-events: none;");
        $("#submit-disabled-tooltip").tooltip('enable');
      }
    }

    function isFormValid() {
      return (compareEmailsAndRequireMatch() && isTicketCountValid());
    }

    function isTicketCountValid() {
      return true;
      //return (parseInt($('#quantity_to_cart_10').val()) > 0);
    }

    function compareEmailsAndRequireMatch() {
      if ($("#purchaser_email").val() && ($("#purchaser_email").val() === $("#purchaser_email_confirm").val())) {
        return true;
      } else {
        return false;
      }
    }

    function reset_modal_to_starting_position() {
      $("#artist-id-1").find(".modal-body").html(starting_position_modal_inner_html);
      $('#form-next').show()

      $("#artist-id-1").on('shown.bs.modal', function () {
        $(".collapsing_description").each((index, element) => {
          if ($(element)[0].clientHeight >= $(element)[0].scrollHeight) {
            $(element).next().toggleClass("d-none");
          }
        })
      })

      $('#form-dismiss').text('Cancel')
      if (document.getElementById('form-next') != null) {
        document.getElementById('form-next').addEventListener('click', screen_one_handler);
        document.getElementById('form-next').removeEventListener('click', screen_two_handler_stripe);

        document.getElementById('form-next').removeEventListener('click', screen_two_rsvp_handler);
        document.getElementById('form-next').removeEventListener('click', screen_two_rsvp_handler_confirm);
      }

    }

    function detect_and_show_ga_or_artist_modal() {
      var urlParams = new URLSearchParams(window.location.search); //get all parameters
      var buy_artist = urlParams.get('buy_artist');
      var buy_ga = urlParams.get('buy_ga');

      if (buy_artist) { //check if foo parameter is set to anything
        $("a.support-artist[data-band-id=" + buy_artist + "]").click()
      }

      if (buy_ga) { //check if foo parameter is 'bar'
        $("a.support-general-admission").click()
      }

    }

    function showMessage(messageText) {
      const messageContainer = document.querySelector("#payment-message");

      messageContainer.classList.remove("hidden");
      messageContainer.classList.add("alert");
      messageContainer.textContent = messageText;
      $(".modal-body").animate({
        scrollTop: ($("#payment-message").offset().top - 50)
      }, 750);

      setTimeout(function () {
        messageContainer.classList.add("hidden");
        messageContainer.classList.remove("alert");
        messageContainer.textContent = "";
      }, 6000);
    }



    $(function () {
      reset_modal_to_starting_position();
      detect_and_show_ga_or_artist_modal();
    });

  });


}

window.init_ticketnut_checkout = init_ticketnut_checkout;
